export default __webpack_public_path__ + "static/media/14.ee686ee6.jpg";